import * as React from "react";
const ArrowDown = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8555 8.14838C21.0497 8.3447 21.0479 8.66128 20.8516 8.85547L13.0549 16.5678C12.4704 17.1459 11.5296 17.1459 10.9451 16.5678L3.14838 8.85547C2.95205 8.66128 2.95033 8.3447 3.14453 8.14838C3.33872 7.95205 3.6553 7.95033 3.85162 8.14453L11.6484 15.8569C11.8432 16.0496 12.1568 16.0496 12.3516 15.8569L20.1484 8.14453C20.3447 7.95033 20.6613 7.95205 20.8555 8.14838Z"
            fill="#949494"
        />
    </svg>
);
export default ArrowDown;
